
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PackageInfluencers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InfluencerSearchSortBy"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"packageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"packageInfluencers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"packageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"influencerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followersCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageEngagement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageEngagementRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageEngagementViewsRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engagementProposedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engagementPostedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"socialAccounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialAccountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followersCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageEngagement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageEngagementRate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isAnySignedUpAccountForYoutube"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAnySignedUpAccountForTwitter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAnySignedUpAccountForTiktok"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAnySignedUpAccountForInstagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAnySignedUpAccountForFacebook"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":809}};
    doc.loc.source = {"body":"query PackageInfluencers($packageId: Int!, $orderBy: InfluencerSearchSortBy) {\n  package(packageId: $packageId) {\n    name\n  }\n  packageInfluencers(packageId: $packageId, orderBy: $orderBy) {\n    influencerId\n    name\n    tags\n    status\n    avatar\n    followersCount\n    averageEngagement\n    averageEngagementRate\n    averageEngagementViewsRate\n    country {\n      id\n      name\n    }\n    categories\n    gender\n    age\n    engagementProposedCount\n    engagementPostedCount\n    socialAccounts {\n      socialAccountId\n      socialMedia\n      name\n      followersCount\n      averageEngagement\n      averageEngagementRate\n    }\n    isAnySignedUpAccountForYoutube\n    isAnySignedUpAccountForTwitter\n    isAnySignedUpAccountForTiktok\n    isAnySignedUpAccountForInstagram\n    isAnySignedUpAccountForFacebook\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PackageInfluencers"] = oneQuery(doc, "PackageInfluencers");
        
